/**
 * Image Slider Widget JS
 *
 * @since   1.0.0
 * @package premier
 */
(function($) {
    // Hook for when elementor front end is loaded
    $(window).on('elementor/frontend/init', function() {
        //hook name is 'frontend/element_ready/{widget-name}.{skin}
        //$scope is a jquery wrapped parent element
        elementorFrontend.hooks.addAction('frontend/element_ready/image-slider.default', function($scope) {

            $('.image-slider').flickity({
                cellAlign: 'left',
                contain: true,
				prevNextButtons: false,
				selectedAttraction: 0.01,
				friction: 0.15,
            });
			// change default flickity buttons
            $('.flickity-button.flickity-prev-next-button.next').html('<i class="fas fa-long-arrow-right"></i>');
            $('.flickity-button.flickity-prev-next-button.previous').html('<i class="fas fa-long-arrow-left"></i>');

        });
    });

})(jQuery);
